import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { cookRequestParams } from '@/common/request'

const cookUrl = (name) => `${v2Host}/dashboard/playturbo/${name}`

export function getSummary(params) {
  return request({
    url: cookUrl('summary'),
    method: 'get',
    params,
  })
}

export function getAdv() {
  return request({
    url: cookUrl('adv-tpls'),
    method: 'get',
  })
}

export function getVisitors(params) {
  return request({
    url: cookUrl('visitors'),
    method: 'get',
    params,
  })
}

// http://127.0.0.1:8067/index.html#/dashboard/get_dashboard_playturbo_summary_usages
export function getSummaryUsages(params) {
  return request({
    url: cookUrl('summary-usages'),
    method: 'get',
    params: cookRequestParams(params),
  })
}

// http://127.0.0.1:8067/index.html#/dashboard/get_dashboard_playturbo_summary_usages
export function getTplUsages(params) {
  return request({
    url: cookUrl('tpl-usages'),
    method: 'get',
    params: cookRequestParams(params),
  })
}

// http://127.0.0.1:8067/index.html#/dashboard/get_dashboard_playturbo_summary_usages
export function getUsages(params) {
  return request({
    url: cookUrl('usages'),
    method: 'get',
    params: cookRequestParams(params),
  })
}

export function getAiUsages(params) {
  return request({
    url: `${v2Host}/dashboard/ai/usage-report`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

export function getVrecordUsages(params) {
  return request({
    url: `${v2Host}/dashboard/vrecord/usage-report`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

export function getVeditorUsages(params) {
  return request({
    url: `${v2Host}/dashboard/veditor/usage-report`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

export function getCloudUsages(params) {
  return request({
    url: `${v2Host}/dashboard/ceditor/usage-report`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

export function getXmpReport(params) {
  return request({
    url: `${v2Host}/dashboard/ceditor/xmp-report`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

export function getPlayableProjectList(params) {
  return request({
    url: `${v2Host}/dashboard/playturbo/playable-project-list`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

export function getVideoProjectList(params) {
  return request({
    url: `${v2Host}/dashboard/playturbo/video-project-list`,
    method: 'get',
    params: cookRequestParams(params),
  })
}
